import { useTranslation } from 'react-i18next';
import select from '@assets/img/select.svg';
function ReportDamage() {
  const { t } = useTranslation();
  return (
    <div className="w-full bg-[#F5F5F5] py-[6.25rem]">
      <div className="w-10/12 m-auto">
        <div>
          <h2 className="text-primary font-bold text-[2.5rem]">{t('reportDamage.title')}</h2>
        </div>
        <div className="flex flex-col xl:flex-row xl:justify-around">
          <div className="py-[2rem]">
            <img src={select} className="w-[22.5rem] m-auto" />
          </div>
          <div className="flex flex-col items-start relative items-center justify-center">
            <div className="flex flex-row relative">
              <div className=" absolute top-0 left-[27px] h-[15rem] w-[2px] bg-secondary z-[0]"></div>
              <div className="rounded-full w-14 h-14 border-2 border-solid border-secondary hover:border-primary text-lg text-center p-3 mb-[2.25rem] bg-[#F5F5F5] z-[2]">
                1
              </div>
              <div className="pt-[1rem] w-[21rem] xl:w-[36rem] px-[1rem]">
                {t('reportDamage.step1')}
              </div>
            </div>
            <div className="flex flex-row relative">
              <div className="rounded-full w-14 h-14 border-2 border-solid border-secondary hover:border-primary text-lg text-center p-3 mb-[2.25rem] bg-[#F5F5F5]">
                2
              </div>
              <div className="pt-[1rem] w-[21rem] xl:w-[36rem] px-[1rem]">
                {t('reportDamage.step2')}
              </div>
            </div>
            <div className="flex flex-row relative">
              <div className="rounded-full w-14 h-14 border-2 border-solid border-secondary hover:border-primary text-lg text-center p-3 mb-[2.25rem] bg-[#F5F5F5]">
                3
              </div>
              <div className="pt-[1rem] w-[21rem] xl:w-[36rem] px-[1rem]">
                {t('reportDamage.step3')}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default ReportDamage;
